import type {
  PdfPriceList,
  QueryParams,
  PriceCategory,
  PriceCategoryPagedResult,
  PriceDetail,
  PricesPagedResult,
} from '~/types/api'

export function createPricesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN_PRICES = 'prices'
  const DOMAIN_CATEGORIES = 'price-categories'
  const DOMAIN_PDF_PRICE_LIST = 'pdf-price-lists'

  async function getAll(params?: QueryParams) {
    return get<PricesPagedResult>([DOMAIN_PRICES], { params })
  }

  async function getByNid(nid: number) {
    return get<PriceDetail>([DOMAIN_PRICES, nid.toString()])
  }

  async function getAllCategories(params?: QueryParams) {
    return get<PriceCategoryPagedResult>([DOMAIN_CATEGORIES], {
      params,
    })
  }

  async function getCategory(id: number) {
    return get<PriceCategory>([DOMAIN_CATEGORIES, id.toString()])
  }

  async function getPdfPriceList(params: {
    customerGroupNid?: number
    priceCategoryNid?: number
  }) {
    return get<PdfPriceList>([DOMAIN_PDF_PRICE_LIST], {
      params,
    })
  }

  async function getLinePdfPriceList(params: {
    customerGroupNid?: number
    priceCategoryNid?: number
    productLineTnid: number // NOTE: not a typo, EP uses tnid here
  }) {
    return get<PdfPriceList>([DOMAIN_PDF_PRICE_LIST], {
      params,
    })
  }

  return {
    getAll,
    getByNid,
    getAllCategories,
    getCategory,
    getPdfPriceList,
    getLinePdfPriceList,
  }
}
